import * as systemsActions from '../actions/Systems';

const initialState = {
  list: []
};

const systems = (state = initialState, action) => {
  switch (action.type) {
    case systemsActions.GET_SYSTEMS_SUCCESS:
      return Object.assign({}, state, { list: action.payload.connectSystems });
    case systemsActions.GET_SYSTEMS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default systems;
